import React, { lazy } from 'react';
import Loadable from 'app/components/Loadable';
import OrgLayout from './OrgLayout';
import RedirectToTab from './workspace/components/RedirectToTab';

const OrgWorkspace = Loadable(lazy(() => import('./workspace/OrgWorkspace')));
const OrgCreate = Loadable(lazy(() => import('./OrgCreate')));

// `/org/:orgId` now renders the unified OrgWorkspace; the tab lives in the
// `?tab=` query. The legacy path-segment children (`/users`, `/settings`,
// `/analytics`) redirect to the new query form so existing bookmarks and
// external links keep working. OrgDetails / OrgSettings / OrgUsersSection /
// OrgDashboard are still imported by the panels they back, but no longer
// have their own routes.
const orgRoutes = [
    {
        path: '/org/:orgId',
        element: <OrgLayout />,
        children: [
            { path: '', element: <OrgWorkspace /> },
            { path: 'users', element: <RedirectToTab tab="users" /> },
            { path: 'settings', element: <RedirectToTab tab="settings" /> },
            { path: 'analytics', element: <RedirectToTab tab="analytics" /> },
        ],
    },
    {
        path: '/org/create',
        element: <OrgCreate />,
    },
];

export default orgRoutes;
